import Backbone from 'backbone';
import ReactDOM from 'react-dom';
import React from 'react';

// @aiContributed-MAPFuse-2026-06-05
/* eslint-disable no-unused-vars */
export type AdExtensionEditorAdapterCallback = (...args: unknown[]) => void;

export interface AdExtensionEditorAdapterOptions extends Backbone.ViewOptions<Backbone.Model> {
  onCreated?: AdExtensionEditorAdapterCallback;
  onUpdated?: AdExtensionEditorAdapterCallback;
  onCancel?: AdExtensionEditorAdapterCallback;
  onRemove?: AdExtensionEditorAdapterCallback;
  [key: string]: unknown;
}

export interface AdExtensionEditorAdapterComponentProps extends AdExtensionEditorAdapterOptions {
  onCreated: AdExtensionEditorAdapterCallback;
  onUpdated: AdExtensionEditorAdapterCallback;
  onCancel: AdExtensionEditorAdapterCallback;
  onRemove: AdExtensionEditorAdapterCallback;
}

export type AdExtensionEditorAdapterComponent = React.ComponentType<AdExtensionEditorAdapterComponentProps>;

export type AdExtensionEditorAdapterViewConstructor = new (
  options?: AdExtensionEditorAdapterOptions
) => Backbone.View<Backbone.Model>;

interface DecoratedViewRuntime extends Backbone.View<Backbone.Model> {
  options: AdExtensionEditorAdapterComponentProps;
  delegateCallback(eventName: string): AdExtensionEditorAdapterCallback;
}

interface BackboneViewWithExtend {
  extend(protoProps: {
    initialize(this: DecoratedViewRuntime, options: AdExtensionEditorAdapterOptions): void;
    delegateCallback(this: DecoratedViewRuntime, eventName: string): AdExtensionEditorAdapterCallback;
    render(this: DecoratedViewRuntime): DecoratedViewRuntime;
    remove(this: DecoratedViewRuntime): void;
  }): AdExtensionEditorAdapterViewConstructor;
}
/* eslint-enable no-unused-vars */

export const reactAdExtensionEditorAdapter = (ReactComponent: AdExtensionEditorAdapterComponent) => {
  const DecoratedView = (Backbone.View as unknown as BackboneViewWithExtend).extend({
    initialize(options: AdExtensionEditorAdapterOptions) {
      this.options = {
        ...options,
        onCreated: this.delegateCallback('created'),
        onUpdated: this.delegateCallback('updated'),
        onCancel: this.delegateCallback('cancel'),
        onRemove: this.delegateCallback('remove'),
      };
    },

    delegateCallback(eventName: string) {
      return (...args: unknown[]) => this.trigger(eventName, ...args);
    },

    render() {
      ReactDOM.render(
        (
          <ReactComponent {...this.options} />
        ),
        this.el
      );

      return this;
    },

    remove() {
      ReactDOM.unmountComponentAtNode(this.el);
      Backbone.View.prototype.remove.call(this);
    },
  });

  return DecoratedView;
};
